import Image from '@/shared/components/Image/new'
import styles from './styles.module.css'

const AdemasTenesQueLeer = ({ relatedNews, parentId }) => {

    return (
        <>
            {
            relatedNews && relatedNews.length > 0 && (
                <div className={`${styles['related-news-container']}`}>
                    <h2 className={`${styles['related-news-title']}`}>
                        Además tenés que leer:
                    </h2>
                    <ul className={styles["related-news-content-list"]}>
                        {relatedNews.map(({ value, _id }) => {
                            const relatedNewsImageCrop = '3_2_300x200';

                            if (value && value.url) {
                                const {
                                    url = '',
                                    title,
                                    subtitle,
                                    related
                                } = value;

                                let element = related && related.images && related.images.length > 0 && related.images[0] && related.images[0].value &&
                                {
                                    images: [
                                        {
                                            clippings: related.images[0].value.clippings ? related.images[0].value.clippings : [],
                                            title: related.images[0].value.title ? related.images[0].value.title : '',
                                        }
                                    ]
                                }
				if (element === undefined) { console.error('parent ID: ' + parentId); }
                                return (
                                    <li className={`${styles['related-news-content']}`} key={_id}>
                                        <a href={url}>
                                            <Image
                                                element={element}
                                                clipping={relatedNewsImageCrop}
                                                width={300}
                                                height={200}
                                                className={`${styles["img"]}`}
                                            />
                                            <div className={`${styles['related-news-content-title']}`}>
                                            <span className={`${styles["blue-txt"]}`}>{subtitle}</span> {title}
                                            </div>
                                        </a>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                </div>
            )
        }
        </>

    )
}

export default AdemasTenesQueLeer
